import { render, staticRenderFns } from "./ChangguanHome.vue?vue&type=template&id=cb555cfa&scoped=true"
import script from "./ChangguanHome.vue?vue&type=script&lang=js"
export * from "./ChangguanHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb555cfa",
  null
  
)

export default component.exports